export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, function (txt: string) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function pluralizationHelper(string: string, count: number) {
  const fullString = count + " " + string;
  const isOne = count === 1;
  if (!isOne) {
    return fullString;
  }
  return fullString.slice(0, -1);
}

export const truncateText = (text: string, length = 10) => {
  if (!text) return text;
  return text.length > length ? text.substring(0, length - 3) + "..." : text;
};
